import * as React from 'react';

const BasketIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 210.36 185.53"
    width={25}
    height={24}
    {...props}
  >
    <path d="M204.36 69.11c-.14 0-.28.01-.42.02v-.03h-20.17L153.85 0H136.4v.03c-.18-.02-.35-.03-.54-.03-3.31 0-6 2.68-6 6s2.68 6 6 6c.18 0 .36-.01.54-.03v.04h9.57l24.73 57.1H39.07L63.8 12h9.57v-.03c3.13-.2 5.61-2.8 5.61-5.98S76.49.22 73.36.02V0H55.91L25.99 69.1H6c-3.31 0-6 2.69-6 6s2.68 6 6 6h8.71l12.64 104.43h154.14L196.66 81.1h7.28v-.02c.14 0 .28.02.42.02 3.31 0 6-2.68 6-6s-2.68-6-6-6Zm-33.25 104.42H37.98L26.79 81.1h157.74l-13.43 92.43Z" />
    <path d="M104.97 160.06c3.31 0 6-2.68 6-6v-50.4h-.01c-.08-3.24-2.73-5.84-5.99-5.84s-5.9 2.6-5.99 5.84h-.01v50.4c0 3.31 2.68 6 6 6ZM139.97 160c3.3.21 6.15-2.3 6.36-5.6l3.21-50.29h-.01c.12-3.24-2.35-6-5.6-6.21-3.25-.21-6.06 2.22-6.35 5.45h-.01l-3.21 50.29c-.21 3.3 2.3 6.15 5.6 6.36ZM64.31 154.45c.25 3.3 3.13 5.78 6.43 5.53s5.78-3.13 5.53-6.43-3.78-50.25-3.78-50.25h-.01c-.33-3.22-3.16-5.62-6.41-5.37-3.25.24-5.69 3.04-5.53 6.27h-.01l3.78 50.25Z" />
  </svg>
);

export default BasketIcon;
